import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../app.constants';

@Component({
    selector: 'app-get-involved',
    templateUrl: './get-involved.component.html',
    styleUrls: ['./get-involved.component.scss'],
})
export class GetInvolvedComponent implements OnInit {
    private readonly errorMessage = 'Unfortunately, something has gone wrong. Please consider getting in touch with the MARIS Team at the IAEA Marine Environment Laboratories in Monaco by email(NAEL-MARIS.Contact-Point@iaea.org) instead.';
    private readonly successMessage = 'Thank you for your interest in MARIS. Your details have been successfully received. The MARIS Team at the IAEA Marine Environment Laboratories in Monaco will get back to you soon.';
    getInvolvedForm: FormGroup;
    submitted = false;
    emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
    URL = `${this.constants.apiUrl}/GetInvolved/contactsubmission/`;
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    notChecked = true;

    constructor(private formBuilder: FormBuilder,
        private constants: Constants,
        private http: HttpClient) { }

    ngOnInit(): void {
        this.getInvolvedForm = this.formBuilder.group(
            {
                nameabc: ['', Validators.required],
                emailbcd: ['', [Validators.required, Validators.pattern(this.emailPattern),],],
                otherAreaOfInterest: [''],
                confirmEmail: ['', Validators.required],
                acceptGDPR: [false, Validators.requiredTrue]
            },
            {
                validator: this.mustMatch('emailbcd', 'confirmEmail'),
            });
        let acceptGDPR = this.getInvolvedForm.get('acceptGDPR');
        acceptGDPR.valueChanges.subscribe((value) => {

            if (value) {
                this.notChecked = false;
            } else {
                this.notChecked = true;
            }
        });
    }

    get f() {
        return this.getInvolvedForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        if (this.getInvolvedForm.invalid)
            return;

        const formData = new FormData();
        formData.append('name', this.getInvolvedForm.value.nameabc);
        formData.append('email', this.getInvolvedForm.value.emailbcd);
        formData.append('interestTopicOther', this.getInvolvedForm.value.otherAreaOfInterest)
        this.http.post(this.URL, formData).subscribe(() => {
            alert(this.successMessage);
            this.submitted = false;
            this.getInvolvedForm.reset();
        }, () => alert(this.errorMessage));
    }

    mustMatch(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }
}
